import { render, staticRenderFns } from "./updateCardInfo.vue?vue&type=template&id=21d86c7d&scoped=true&"
import script from "./updateCardInfo.vue?vue&type=script&lang=js&"
export * from "./updateCardInfo.vue?vue&type=script&lang=js&"
import style0 from "./updateCardInfo.vue?vue&type=style&index=0&id=21d86c7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d86c7d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VForm,VRow})
